module.exports = __webpack_public_path__ + "static/img/s1.931e571.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CorporateTravel/s1.png
// module id = C33a
// module chunks = 1